import { useQueryClient } from '@tanstack/react-query';
import { useDisconnect as useWagmiDisconnect } from 'wagmi';

export function useDisconnect() {
  const { mutate } = useWagmiDisconnect();
  const queryClient = useQueryClient();

  const disconnect = () => {
    mutate();
    // Clear user-related data from the storage
    queryClient.removeQueries({ queryKey: ['userBalance'] });
  };

  return disconnect;
}
